import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';

import {
  Avatar,
  Box,
  Group,
  Menu,
  rem,
  ScrollArea,
  Text,
  ThemeIcon,
} from '@mantine/core';
import { openModal } from '@mantine/modals';
import { IconChevronRight, IconKey, IconLogout } from '@tabler/icons-react';

import useAuth from '@hooks/useAuth';

import EditUserPasswordForm from '@components/EditUserPasswordForm';

import logo from '@assets/images/logo.png';

import { linksData } from '../../../data/linksData';
import classes from './Sidebar.module.css';

interface SidebarProps {
  onLinkClick: () => void;
}

export default function Sidebar({ onLinkClick }: SidebarProps) {
  const { user, logout } = useAuth();

  const handleEditPasswordClick = () => {
    openModal({
      title: 'Modifica password',
      children: <EditUserPasswordForm />,
    });
  };

  const links = linksData.map((item) => {
    return (
      <NavLink to={item.link} className={classes.link} onClick={onLinkClick}>
        <Group justify="space-between" gap={0}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <ThemeIcon variant="transparent" size={25}>
              <item.icon style={{ width: '100%', height: '100%' }} />
            </ThemeIcon>
            <Box ml="md">{item.label}</Box>
          </Box>
        </Group>
      </NavLink>
    );
  });

  const userInitials = useMemo(() => {
    if (user) {
      return user.name
        .split(' ')
        .map((w) => w[0])
        .join('');
    }

    return '';
  }, [user]);

  return (
    <nav className={classes.sidebar}>
      <div className={classes.header}>
        <img src={logo} alt="Logo Ieis" style={{ height: rem(70) }} />
      </div>

      <ScrollArea className={classes.links}>
        <div className={classes.linksInner}>{links}</div>
      </ScrollArea>

      <div className={classes.footer}>
        <Menu position="right-end" withArrow>
          <Menu.Target>
            <Group wrap="nowrap" className={classes.user}>
              <Avatar size="2.5rem" color="brand">
                {userInitials}
              </Avatar>

              <div style={{ flex: 1 }}>
                <Text size="sm" fw={500}>
                  {user!.name}
                </Text>
              </div>

              <IconChevronRight
                style={{ width: rem(14), height: rem(14) }}
                stroke={1.5}
              />
            </Group>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={handleEditPasswordClick}>
              <Group>
                <IconKey size="1.5rem" />
                <Text size="sm">Modifica password</Text>
              </Group>
            </Menu.Item>
            <Menu.Item onClick={logout} c="red">
              <Group>
                <IconLogout size="1.5rem" />
                <Text size="sm">Logout</Text>
              </Group>
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
    </nav>
  );
}
